//import logo from './logo.svg';
import {Link} from 'react-router-dom';


function Nav({active})
{
    let yearSelected="?year=2020";
    let crrURL=window.location.href;
    if(crrURL.substring(crrURL.search("year")+5, crrURL.search("year")+9)==="2020")
      yearSelected="?year=2020";
    if(crrURL.substring(crrURL.search("year")+5, crrURL.search("year")+9)==="2021")
      yearSelected="?year=2021";

    let butActive1="first leaf ";
    let butActive2="leaf ";
    let butActive3="leaf ";
    let butActive4="leaf ";
    let butActive5="last leaf ";
    let href1="/GBL";// + yearSelected;
    let href2="/Pillar2/GBL";// + yearSelected;
    let href3="/Pillar3/GBL";// + yearSelected;
    let href4="/Pillar4/GBL";// + yearSelected;
    let href5="/Pillar5/GBL";// + yearSelected;
  
  
    // // console.log(active);
    switch (active) {
      case "p1":
        butActive1 += "active-trail";
        break;
      case "p2":
        butActive2 += "active-trail";
        break;
      case "p3":
        butActive3 += " active-trail";
        break;
      case "p4":
        butActive4 += " active-trail";
        break;
      case "p5":
        butActive5 += " active-trail";
        break;
      default:
        butActive1 += "active-trail";
        break;
    }
    return(
      <div className="customcontainer main-menu-wrapper">
        <div id="block-system-main-menu" className="block block-system block-menu">
            <h2>Main menu</h2>
            <div className="menu-wrapper">
              <div className="content">
                  <ul className="menu">
                      <li className={butActive1}><a id="pilar1-link" href={href1}>Health first</a></li>
                      <li className={butActive2}><a id="pilar2-link" href={href2}>Protecting people</a></li>
                      <li className={butActive3}><a id="pilar3-link" href={href3}>Economic Response</a></li>
                      <li className={butActive4}><a id="pilar4-link" href={href4}>Macroeconomic response</a></li>
                      <li className={butActive5}><a id="pilar5-link" href={href5}>Social Cohesion</a></li>
                  </ul>
              </div>
            </div>
        </div>
      </div>
    ) 
  }

export default Nav;